export default __webpack_public_path__ + "static/media/02_Awaken-DAO.0bcc8eb6.png";